<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

  import {initMenu} from "@/utils/menus";
  import router from "@/router";
  import store from "@/store";

  export default {
    created() {

      if(router.currentRoute.path != '/') {
        initMenu(router, store);
      };

      // 浏览器控制按钮前进后退触发函数
      window.addEventListener('popstate', this.popstate, false);
    },

    methods: {
      //浏览器后退物理按钮触发
      //监听触发事件--------回退到登录页
      popstate() {
        this.$router.push('/');
      }
    }

  }


</script>

<style>

  .is-flex {
    display: flex;
    align-content: center;
    justify-content: space-between;
  }

  .full-image {
    width: 100%;
    height: 100%;
  }

</style>
